import React from "react";
import ThreatIncidentManagement from "components/newDesign/threats/ThreatIncidentManagement";

const ThreatsIncidentsPage = () => {
  return <ThreatIncidentManagement />;
};

export default ThreatsIncidentsPage;
